const isACookieProduct = (name: string) => {
    return name.toLowerCase().includes('cookie');
};

export default isACookieProduct;
